import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
      localStorage.removeItem("bs_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // AuthCallback exchanges the session_id first; skip the /me check in that case.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const applyUser = (data) => {
    if (data?.token) localStorage.setItem("bs_token", data.token);
    setUser(data);
  };

  const login = async (email, password) => applyUser((await api.post("/auth/login", { email, password })).data);
  const register = async (name, email, password) => applyUser((await api.post("/auth/register", { name, email, password })).data);
  const googleSession = async (session_id) => applyUser((await api.post("/auth/google/session", { session_id })).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("bs_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, googleSession, logout, refresh, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
